module.exports = __webpack_public_path__ + "img/empty_person.80b24a05.png";